import { FC } from "react";

export interface TriadicIconProps {}

export const TriadicIcon: FC<TriadicIconProps> = ({}) => {
    return (
        <svg width="300" height="300" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1376_8910)">
                <path
                    d="M141.994 17.0078C141.835 17.0078 141.677 17.0078 141.518 17.0078C115.889 17.0078 91.8442 23.874 71.0762 35.7578L141.941 158.451V17.0078H141.994Z"
                    fill="#FEF121"
                />
                <path
                    d="M71.1282 35.8105C60.2422 42.0429 50.2545 49.6486 41.4823 58.469C32.8157 67.131 25.3117 76.9021 19.1289 87.5711L142.046 158.504L71.1282 35.8105Z"
                    fill="#8AD21B"
                />
                <path
                    d="M264.224 87.9403C257.988 77.1129 250.379 67.1833 241.607 58.4157C232.993 49.8065 223.217 42.3065 212.648 36.127L141.994 158.504L264.224 87.9403Z"
                    fill="#F6AC43"
                />
                <path
                    d="M212.648 36.1803C191.88 24.0853 167.73 17.1134 141.994 17.0078V158.504L212.648 36.1803Z"
                    fill="#FACE32"
                />
                <path
                    d="M283.143 158.505C283.143 132.836 276.273 108.751 264.277 87.9941L141.994 158.505H283.143Z"
                    fill="#FB7833"
                />
                <path d="M19.077 87.5703C6.97552 108.433 0 132.623 0 158.503H141.994L19.077 87.5703Z" fill="#34B534" />
                <path
                    d="M19.0762 229.437C25.259 240.106 32.763 249.877 41.4295 258.539C50.2546 267.36 60.2423 274.965 71.0755 281.198L141.94 158.504L19.0762 229.437Z"
                    fill="#197AC4"
                />
                <path d="M0 158.504C0 184.384 6.97552 208.574 19.077 229.437L141.994 158.504H0Z" fill="#1BB3CF" />
                <path
                    d="M141.994 158.504L264.224 229.014C276.22 208.257 283.09 184.173 283.09 158.504H141.994Z"
                    fill="#FF4929"
                />
                <path
                    d="M212.648 280.828C223.269 274.648 232.993 267.201 241.607 258.539C250.379 249.771 257.988 239.842 264.224 229.014L141.994 158.504L212.648 280.828Z"
                    fill="#D24499"
                />
                <path
                    d="M71.1289 281.198C91.8969 293.134 115.888 299.948 141.571 299.948C141.73 299.948 141.888 299.948 142.047 299.948V158.504L71.1289 281.198Z"
                    fill="#525EBA"
                />
                <path
                    d="M141.994 299.948C167.73 299.842 191.88 292.87 212.648 280.775L141.994 158.504V299.948Z"
                    fill="#7E38B0"
                />
                <path
                    d="M40.373 264.456L105.372 16.5859L283.301 195.266L40.373 264.456ZM108.12 26.8852L47.8242 256.85L273.207 192.678L108.12 26.8852Z"
                    className="fill-black dark:fill-white"
                />
                <path
                    d="M125.402 25.8809C123.077 36.1802 112.878 42.6238 102.573 40.2999C92.2681 37.9759 85.8211 27.7823 88.1462 17.483C90.4714 7.18367 100.67 0.740011 110.975 3.06396C121.227 5.44072 127.674 15.6344 125.402 25.8809Z"
                    fill="#FEF121"
                />
                <path
                    d="M106.747 43.4693C105.161 43.4693 103.576 43.3108 101.991 42.9411C96.3362 41.6735 91.4745 38.2932 88.4095 33.3813C85.2917 28.4693 84.2876 22.6594 85.5559 17.008C88.1453 5.28266 99.824 -2.1117 111.503 0.529143C123.181 3.16999 130.58 14.7897 127.937 26.4622C125.665 36.6031 116.681 43.4693 106.747 43.4693ZM106.747 5.28266C99.2427 5.28266 92.4257 10.5115 90.6818 18.1172C89.7306 22.3953 90.4705 26.7791 92.8485 30.5291C95.1736 34.2263 98.8728 36.8144 103.153 37.7651C111.978 39.7721 120.803 34.1735 122.811 25.3003C124.82 16.4798 119.218 7.65942 110.34 5.65238C109.125 5.3883 107.909 5.28266 106.747 5.28266Z"
                    className="fill-black dark:fill-white"
                />
                <path
                    d="M62.726 264.824C60.4009 275.124 50.2018 281.567 39.8971 279.243C29.5924 276.919 23.1453 266.726 25.4705 256.426C27.7956 246.127 37.9947 239.683 48.2994 242.007C58.5513 244.331 65.0512 254.578 62.726 264.824Z"
                    fill="#197AC4"
                />
                <path
                    d="M44.1246 282.413C42.5393 282.413 40.9539 282.254 39.3686 281.885C27.6899 279.244 20.2916 267.624 22.9339 255.951C25.5761 244.279 37.202 236.885 48.8807 239.525C60.5594 242.166 67.9576 253.786 65.3154 265.458C63.0431 275.494 54.0595 282.413 44.1246 282.413ZM44.1246 244.226C36.6207 244.226 29.8037 249.455 28.0598 257.061C26.0517 265.881 31.6533 274.701 40.5312 276.708C49.3563 278.716 58.1813 273.117 60.1894 264.244C62.1976 255.423 56.596 246.603 47.7181 244.596C46.5026 244.332 45.2872 244.226 44.1246 244.226Z"
                    className="fill-black dark:fill-white"
                />
                <path
                    d="M296.882 198.117C294.557 208.416 284.358 214.86 274.053 212.536C263.749 210.212 257.302 200.019 259.627 189.719C261.952 179.42 272.151 172.976 282.456 175.3C292.708 177.624 299.207 187.871 296.882 198.117Z"
                    fill="#FF4929"
                />
                <path
                    d="M278.281 215.706C276.696 215.706 275.11 215.547 273.525 215.178C261.846 212.537 254.448 200.917 257.09 189.244C259.732 177.572 271.358 170.177 283.037 172.818C288.691 174.086 293.553 177.466 296.618 182.378C299.736 187.29 300.74 193.1 299.472 198.751C297.199 208.787 288.216 215.706 278.281 215.706ZM278.281 177.519C270.777 177.519 263.96 182.748 262.216 190.354C260.208 199.174 265.809 207.994 274.687 210.001C283.512 212.008 292.338 206.41 294.346 197.537C295.297 193.258 294.557 188.822 292.179 185.125C289.801 181.427 286.155 178.839 281.874 177.889C280.659 177.625 279.443 177.519 278.281 177.519Z"
                    className="fill-black dark:fill-white"
                />
            </g>
            <defs>
                <clipPath id="clip0_1376_8910">
                    <rect width="300" height="300" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
